<template>
  <v-container fluid grid-list-sm>
    <slot name="header"></slot>
    <v-row dense>
      <v-col sm="6" md="2" v-for="course in courses" :key="course.id">
        <v-card class="mx-auto">
          <v-card-text class="flux-text">
            <div class="teal">
              <div class="pa-2">
                <v-btn dark icon color="white" :to="`/courses/${course.id}`" left>
                  <v-icon>mdi-bookmark-box-multiple</v-icon>
                </v-btn>
                <a class="white--text" :to="`/courses/${course.id}`">{{ course.name }}</a>
              </div>
              <div class="white--text px-2">{{ course.start }} / {{ course.end }}</div>
              <v-divider />
              <div v-if="course.prof1" class="white--text px-2">{{ course.prof1 }}</div>
              <div v-if="course.prof2" class="white--text px-2">{{ course.prof2 }}</div>
            </div>
          </v-card-text>
          <div class="student-list-container">
            <v-list class="student-list-container">
              <div v-for="(student, index) in course.students" :key="index">
                <v-list-item class="student-list" :to="`/students/${student.id}`">
                  <v-list-item-content>
                    <v-list-item-title>{{ student.first_name }} {{ student.last_name }}</v-list-item-title>
                    <v-list-item-subtitle>
                      Taux de présence:
                      <span v-if="student.presence_rate !== null">{{ student.presence_rate }}</span>
                      <v-progress-circular v-else indeterminate size="12" width="2" color="grey" />
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider v-if="index + 1 < course.students.length"></v-divider>
              </div>
            </v-list>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    courses: {
      type: Array,
      required: true,
    },
  },
}
</script>
<style scoped>
.course-title {
  padding: 10px 0;
}
.flux-text {
  padding: 0;
}
</style>
